import styled, { createGlobalStyle } from "styled-components";

export const StyledApp = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
export const GlobalStyle = createGlobalStyle`
  html, body, #root {
    background-color: #fff;
    height: 100%;
  }
  .interstate-table-class-text-at-top {
    td {
      vertical-align: top;
    }
  }
`;
